import cookie from 'react-cookies';
import cookieConfig from '../ContentConfig/cookie';

export default {
  setLangs: (langs, newLangs) => ({
    langs: newLangs,
  }),
  setAppLang: (lang, newLang) => ({
    appLang: newLang,
  }),

  setMenuItems: (menutItems, newMenuItems) => ({
    menuItems: newMenuItems,
  }),

  setRoles: (roles, newRoles) => ({
    roles: newRoles,
  }),

  setUserRole: (userRole, newUserRole) => ({
    userRole: newUserRole,
  }),

  setUser: (user, newUser) => ({
    user: newUser,
  }),

  setSettings: (settings, newSettings) => ({
    settings: newSettings,
  }),

  setMenuState: (menuState, newMenuState) => {
    localStorage.setItem('menuState', newMenuState);
    return {
      menuState: newMenuState,
    };
  },

  setActiveCart: (activeCart, newActiveCart) => {
    localStorage.setItem('activeCart', newActiveCart);
    return {
      activeCart: newActiveCart,
    };
  },
  setCarts: (carts, newCarts) => ({
    carts: newCarts,
  }),

  setCart: (cart, newCart) => {
    // console.log(cart, newCart);
  },

  updateCarts: (state, updateCart) => {
    const newCarts = state.carts.map(cart => {
      if (cart._id === updateCart._id) {
        return updateCart;
      }
      return cart;
    });
    return {
      carts: newCarts,
    };
  },
  setHeader: (header, newHeader) => ({
    header: newHeader,
  }),

  setActiveMenuItem: (activeMenuItem, newActiveMenuItem) => ({
    activeMenuItem: newActiveMenuItem,
  }),

  setLoggingOut: (loggingOut, value) => {
    return { loggingOut: value };
  },
  logout: async () => {
    window.location.href = '/';
    //const AccessToken = cookie.load(cookieConfig.name);
    cookie.remove(cookieConfig.name, { path: '/' });
    //TODO move to APIv2
    //await API2.oauthRevokeAction({ data: { access_token: AccessToken } });
  },
  setFirm: (firm, newFirm) => {
    return {
      firm: newFirm,
    };
  },
  setPath: (history, newHistory) => {
    return { history: newHistory };
  },
  setAclList: (aclList, newAclList) => {
    return { aclList: newAclList };
  },
  setHistory: (userHistory, newHistory) => ({
    userHistory: newHistory,
  }),
  addHistory: (state, newHistoryItem) => {
    const history = [newHistoryItem, ...state.userHistory].slice(0, 10);
    return {
      userHistory: history,
    };
  },
  setYear: (year, newYear) => {
    cookie.save('year', Number(newYear), {
      path: '/',
      expires: new Date(Date.now() + 3600),
      maxAge: 3600,
    });

    return {
      year: Number(cookie.load('year')),
    };
  },
};



// WEBPACK FOOTER //
// ./src/Store/actions.js